"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = Component;
const React = __importStar(require("react"));
const data_upload_1 = require("@genesys/client-core/lib/data-upload");
const Exporter = __importStar(require("@genesys/client-core/lib/exporter"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const LocalElements = __importStar(require("./elements"));
const Workbook = __importStar(require("./templates/workbook"));
const ParseFluidCooling = __importStar(require("./parse-file/parse-fluid-cooling"));
const ParseFluidHeating = __importStar(require("./parse-file/parse-fluid-heating"));
const ParseFreonCooling = __importStar(require("./parse-file/parse-freon-cooling"));
const ParseFreonHeating = __importStar(require("./parse-file/parse-freon-heating"));
const ParseSteamHeating = __importStar(require("./parse-file/parse-steam-heating"));
const ParseGeometry = __importStar(require("./parse-file/parse-geometry2"));
const GeneratedInputs = __importStar(require("./templates/generated-calculation-inputs"));
const Actions = __importStar(require("./actions"));
const Reducer = __importStar(require("./reducer"));
const Variants = __importStar(require("./variants"));
const Title = __importStar(require("./title"));
const Calculate = __importStar(require("./calculate"));
const confirmation_dialog_1 = require("@genesys/client-core/lib/confirmation-dialog");
function Component(props) {
    const [state, dispatch] = React.useReducer(Reducer.reducer, Reducer.initialState);
    React.useEffect(() => {
        if (state.mode === "calculate") {
            (async () => {
                try {
                    const inputs = state.parsedInputs;
                    await createCalculatePromise(inputs, props.graphqlEndpoint, props.authorization);
                    dispatch(Actions.setDoneMode());
                }
                catch (e) {
                    console.log(e);
                    dispatch(Actions.setDoneMode());
                    // biome-ignore lint: -
                    alert("Unexpected error.");
                }
            })();
        }
    }, [state.mode]);
    const exportButton = (si, coilType, enabled) => (React.createElement(Exporter.XlsxMultiSheetsExport, { sheets: Workbook.template(coilType, si), filename: Title.title(coilType) }, onClick => (React.createElement(Elements.StandardButton, { onClick: onClick, disabled: !enabled },
        "Template ",
        si ? "SI" : "IP"))));
    const onImport = (coilType, file) => {
        try {
            const inputs = parseInputs(props.si, coilType, file);
            dispatch(Actions.confirmCalculation(inputs));
        }
        catch (e) {
            // biome-ignore lint: -
            alert(e.message);
        }
    };
    const importButton = (coilType, enabled) => (React.createElement(data_upload_1.XlsxPageUploader, { onParsed: data => onImport(coilType, data) }, onClick => (React.createElement(Elements.StandardButton, { onClick: onClick, disabled: !enabled }, "Find"))));
    /**
     * Upload a workbook with only the Geometry sheet filled; get it back with the operating points a
     * supplier should be asked to run. Fluid coils only - the sizing rules are water-specific.
     */
    const onGenerate = async (si, file) => {
        try {
            // Same trim as the fit path: the Geometry sheet ends at its first fully blank row.
            const endIndex = file[0].findIndex(r => r.every(c => !c));
            const geometrySheet = file[0].slice(0, endIndex !== -1 ? endIndex : file[0].length);
            const geometries = ParseGeometry.parse(geometrySheet, true);
            const coils = await Calculate.fluidCalculationInputs(geometries.map(g => ({ coilId: g.id, geometry: g.geometry })), props.graphqlEndpoint, props.authorization);
            // A matrix can be generated for a coil that cannot be characterised well, so say so before it
            // goes to a supplier rather than after the data comes back unfittable. The warnings
            // themselves live in the sheet, beside the row or the coil they belong to - repeating them
            // here gave a wall of text nobody could match back to a point.
            const hasWarnings = coils.some(c => c.warnings.length > 0 ||
                c.rows.some(r => r.dryWarning !== "" || r.wetWarning !== ""));
            if (hasWarnings) {
                // biome-ignore lint: -
                alert("Inputs generated, but some of them come with warnings. " +
                    "Check the Warnings columns in the sheet before sending it to your supplier.");
            }
            Exporter.download(GeneratedInputs.generatedWorkbook(geometrySheet, coils, si), `Calculation inputs ${si ? "SI" : "IP"}`);
        }
        catch (e) {
            // biome-ignore lint: -
            alert(e.message);
        }
    };
    const generateButton = (si, coilType, enabled) => {
        if (coilType !== "fluid-cooling" && coilType !== "fluid-heating") {
            return null;
        }
        return (React.createElement(data_upload_1.XlsxPageUploader, { onParsed: data => onGenerate(si, data) }, onClick => (React.createElement(Elements.StandardButton, { onClick: onClick, disabled: !enabled },
            "Generate Inputs ",
            si ? "SI" : "IP"))));
    };
    const row = (coilType) => {
        const enabled = state.mode === "ready";
        return (React.createElement("tr", null,
            React.createElement("td", null, Title.title(coilType)),
            React.createElement("td", null, exportButton(true, coilType, enabled)),
            React.createElement("td", null, exportButton(false, coilType, enabled)),
            React.createElement("td", null, importButton(coilType, enabled)),
            React.createElement("td", null, generateButton(true, coilType, enabled)),
            React.createElement("td", null, generateButton(false, coilType, enabled))));
    };
    return (React.createElement(React.Fragment, null,
        state.mode === "ready" && state.parsedInputs && (React.createElement(Elements.AbsoluteOverlay, null,
            React.createElement(confirmation_dialog_1.ConfirmationDialog, { dialog: {
                    type: "ConfirmationPositiveNegative",
                    title: "Calculation",
                    text: "Iterations: " +
                        approxIterations(state.parsedInputs).toLocaleString(),
                    negative: {
                        text: "Cancel",
                        onClick: () => dispatch(Actions.setReadyMode())
                    },
                    positive: {
                        text: "Calculate",
                        onClick: () => dispatch(Actions.setCalculateMode())
                    }
                } }))),
        state.mode === "done" && (React.createElement(Elements.AbsoluteOverlay, null,
            React.createElement(confirmation_dialog_1.ConfirmationDialog, { dialog: {
                    type: "Confirmation",
                    title: "Calculation",
                    text: "Job received, you will be notified by mail when each geometry is done.",
                    positive: {
                        text: "Ok",
                        onClick: () => dispatch(Actions.setReadyMode())
                    }
                } }))),
        React.createElement(Elements.StandardContainer, null,
            React.createElement(Elements.InnerContainer, null,
                React.createElement(Elements.H3, null, "1. Download Excel Template for Inputs for either SI-units or IP-units."),
                React.createElement(Elements.H3, null, "2. Use \"Find\" to upload Excel with inputs and Find coefficients.")),
            React.createElement(Elements.InnerContainer, null,
                React.createElement(LocalElements.Table, null,
                    React.createElement("tbody", null,
                        row("fluid-cooling"),
                        row("fluid-heating"),
                        row("dx"),
                        row("condenser"),
                        row("steam")))))));
}
function parseInputs(si, coilType, file) {
    const endIndex = file[0].findIndex(r => r.every(c => !c));
    const fileData = [
        file[0].slice(0, endIndex !== -1 ? endIndex : file[0].length),
        ...file.slice(1)
    ];
    const variants = Variants.getVariants(fileData[0]);
    switch (coilType) {
        case "fluid-cooling": {
            const inputs = ParseFluidCooling.parse(si, fileData);
            return {
                type: "fluid-cooling",
                inputs: {
                    rows: inputs.rows.map((r, ix) => ({
                        id: r.id,
                        input: r.input,
                        variant: variants[ix]
                    })),
                    velocityUnits: inputs.velocityUnits
                }
            };
        }
        case "fluid-heating": {
            const inputs = ParseFluidHeating.parse(si, fileData);
            return {
                type: "fluid-heating",
                inputs: {
                    rows: inputs.rows.map((r, ix) => ({
                        id: r.id,
                        input: r.input,
                        variant: variants[ix]
                    })),
                    velocityUnits: inputs.velocityUnits
                }
            };
        }
        case "dx": {
            const inputs = ParseFreonCooling.parse(si, fileData);
            return {
                type: "dx",
                inputs: {
                    rows: inputs.rows.map((r, ix) => ({
                        id: r.id,
                        input: r.input,
                        variant: variants[ix]
                    })),
                    velocityUnits: inputs.velocityUnits
                }
            };
        }
        case "condenser": {
            const inputs = ParseFreonHeating.parse(si, fileData);
            return {
                type: "condenser",
                inputs: {
                    rows: inputs.rows.map((r, ix) => ({
                        id: r.id,
                        input: r.input,
                        variant: variants[ix]
                    })),
                    velocityUnits: inputs.velocityUnits
                }
            };
        }
        case "steam": {
            const inputs = ParseSteamHeating.parse(si, fileData);
            return {
                type: "steam",
                inputs: {
                    rows: inputs.rows.map((r, ix) => ({
                        id: r.id,
                        input: r.input,
                        variant: variants[ix]
                    })),
                    velocityUnits: inputs.velocityUnits
                }
            };
        }
        default:
            throw new Error("Unknown type");
    }
}
function approxIterations(inputs) {
    const velocities = getVelocities(inputs);
    if (inputs.type === "fluid-heating" || inputs.type === "fluid-cooling") {
        return 666;
    }
    const input = inputs.inputs.rows[0].input;
    const a = Math.floor((input.aMax - input.aMin) / input.aStep) + 1;
    const b = Math.floor((input.bMax - input.bMin) / input.bStep) + 1;
    if (inputs.type === "condenser") {
        return velocities.reduce((vv, v) => vv + v * a * b, 0);
    }
    const c = Math.floor((input.cMax - input.cMin) / input.cStep) + 1;
    const d = Math.floor((input.dMax - input.dMin) / input.dStep) + 1;
    return velocities.reduce((vv, v) => vv + v * a * b + v * c * d, 0);
}
function getVelocities(inputs) {
    switch (inputs.type) {
        case "fluid-heating":
            return inputs.inputs.rows.map(r => r.input.heatingVelocityInput.length);
        case "condenser":
            return inputs.inputs.rows.map(r => r.input.heatingVelocityInput.length);
        case "fluid-cooling":
            return inputs.inputs.rows.map(r => r.input.coolingVelocityInput.length);
        case "dx":
            return inputs.inputs.rows.map(r => r.input.coolingVelocityInput.length);
        case "steam":
            return inputs.inputs.rows.map(r => r.input.heatingVelocityInput.length);
        default:
            throw new Error("Unknown type");
    }
}
function createCalculatePromise(inputs, graphqlEndpoint, authorization) {
    switch (inputs.type) {
        case "fluid-cooling":
            return Calculate.batchedFluidCooling(inputs.inputs.rows, graphqlEndpoint, authorization);
        case "fluid-heating":
            return Calculate.batchedFluidHeating(inputs.inputs.rows, graphqlEndpoint, authorization);
        case "dx":
            return Calculate.batchedDx(inputs.inputs.rows, graphqlEndpoint, authorization);
        case "condenser":
            return Calculate.batchedCondenser(inputs.inputs.rows, graphqlEndpoint, authorization);
        case "steam":
            return Calculate.batchedSteam(inputs.inputs.rows, graphqlEndpoint, authorization);
        default:
            throw new Error("Unknown type");
    }
}
//# sourceMappingURL=component.js.map